import { useGetQuoteRateQuery } from "apis";
import configs from "config";
import { useRef } from "react";
import { MathRound } from "utils";
import ls from "utils/secureStorage";

export function useQuoteRate(
  type: "buy" | "sell",
  coin: string,
  fiat: string,
  opts?: { fiatAmount: number; cryptoAmount?: number }
) {
  const accessKey = useRef(ls.get(configs.ACCESS_KEY));

  let rateAmount = {
    cryptoAmount: 1,
    fiatAmount: 0 as number,
  };

  if (opts?.cryptoAmount) {
    rateAmount.cryptoAmount = opts.cryptoAmount;
  } else if (opts?.fiatAmount) {
    rateAmount.fiatAmount = opts.fiatAmount;
    rateAmount.cryptoAmount = 0;
  }

  const { data: rate, isFetching } = useGetQuoteRateQuery(
    {
      ...rateAmount,
      fiatType: fiat,
      cryptoType: coin,
      type,
    },
    { skip: !accessKey.current }
  );

  const adjustedRate = { ...rate };
  if (rate?.cryptoAmount !== 1) {
    adjustedRate.fiatAmount = MathRound(Number(adjustedRate.fiatAmount) / Number(adjustedRate.cryptoAmount), 2);
    adjustedRate.cryptoAmount = 1;
  }

  return { rate: adjustedRate, isLoading: isFetching };
}
